enum VerificationStatus {
  /**
   * No documents have been uploaded. Always allow uploading.
   */
  noDocuments = 'noDocuments',
  /**
   * No applications have been submitted. Allow re-uploading, no deleting.
   */
  noApplications = 'noApplications',
  /**
   * 1+ applications have been submitted: the ID is pending admin review. Do not allow modification.
   */
  pending = 'pending',
  /**
   * Admins have rejected this ID. Allow re-uploading, no deleting.
   */
  denied = 'denied',
  /**
   * Admins have approved this ID.
   *
   * TODO discuss what happens when the document has been approved... Gienna says that
   * we don't want to give away too much information in the event that the ID expires and BACP needs
   * user to re-upload.
   *
   * I think we need to show user that their identity has been verified
   * and that this verification is subject to change if their ID expires
   * or BACP invalidates it.
   *
   * Do not allow modification.
   */
  approved = 'approved',
}

export default VerificationStatus;
